import { defineComponent as _defineComponent } from 'vue';
import { SIcon, SImageLazy } from '@strana-artw/ui-kit';
import { differenceInDays } from 'date-fns';
import { computed, defineComponent } from 'vue';
import { useVuexStore } from '@/plugins/app-context';
import { ROUTE_PATHS } from '@/shared/constants';
import StatusDowngradeTimer from '@/shared/ui/loyalty/StatusDowngradeTimer.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyMenuItem',
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var _user$loyalty;
    var emit = _ref.emit;
    defineComponent({
      name: 'LoyaltyMenuItem'
    });
    var user = useVuexStore().$auth.user;
    var isAggregator = computed(function () {
      var _user$agency;
      return (user === null || user === void 0 || (_user$agency = user.agency) === null || _user$agency === void 0 ? void 0 : _user$agency.generalType) === 'aggregator';
    });
    var todayTime = new Date().setHours(0, 0, 0, 0);
    var dateTime = user !== null && user !== void 0 && (_user$loyalty = user.loyalty) !== null && _user$loyalty !== void 0 && _user$loyalty.date_downgrade_status ? new Date(user.loyalty.date_downgrade_status).setHours(0, 0, 0, 0) : 0;
    var daysStatusExpires = dateTime - todayTime > 0 ? Math.abs(differenceInDays(dateTime, todayTime)) : 0;
    var isShowDayDowngradeStatus = computed(function () {
      return dateTime && daysStatusExpires > 0;
    });
    return {
      __sfc: true,
      emit: emit,
      user: user,
      isAggregator: isAggregator,
      todayTime: todayTime,
      dateTime: dateTime,
      daysStatusExpires: daysStatusExpires,
      isShowDayDowngradeStatus: isShowDayDowngradeStatus,
      SIcon: SIcon,
      SImageLazy: SImageLazy,
      ROUTE_PATHS: ROUTE_PATHS,
      StatusDowngradeTimer: StatusDowngradeTimer
    };
  }
});